// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig = {
    apiKey: "AIzaSyAhfVp6wPUPV9un9ZPPBszhggy7VjrfY3w",
    authDomain: "ec-site-903fe.firebaseapp.com",
    projectId: "ec-site-903fe",
    storageBucket: "ec-site-903fe.appspot.com",
    messagingSenderId: "571120215965",
    appId: "1:571120215965:web:f83d4a92bbefcce16d3174",
    measurementId: "G-D2Z318HNSR"
  };